import type { Locale } from "@/lib/i18n";
import { pl, type CPollsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cPollsTranslations: Record<Locale, CPollsTranslations> = {
  pl,
  en,
  de,
};

export type { CPollsTranslations };
